import { createReducer, on } from '@ngrx/store';
import { handleRequest, handleSuccess, handleFailure, handleClear } from '@shared/ngrx-factory/factory.reducer';
import { SupplierApplicationsActions, SupplierDashboardActions, ViewSupplierApplicationActions, RevokeSupplierPrequalificationActions } from './supplier-dashboard.actions';
import { SupplierDashboardState, initialSupplierDashboardState } from './supplier-dashboard.state';

export const supplierDashboardReducer = createReducer(
  initialSupplierDashboardState,
  on(SupplierDashboardActions.request, (state) => handleRequest(state, 'dashboard')),
  on(SupplierDashboardActions.success, (state, { response }) =>
    handleSuccess(state, 'dashboard', response),
  ),
  on(SupplierDashboardActions.failure, (state, { error }) =>
    handleFailure(state, 'dashboard', error),
  ),
  on(SupplierDashboardActions.clearState, (state) => handleClear(state, 'dashboard')),
  on(SupplierApplicationsActions.request, (state) => handleRequest(state, 'applications')),
  on(SupplierApplicationsActions.success, (state, { response }) =>
    handleSuccess(state, 'applications', response),
  ),
  on(SupplierApplicationsActions.failure, (state, { error }) =>
    handleFailure(state, 'applications', error),
  ),
  on(SupplierApplicationsActions.clearState, (state) => handleClear(state, 'applications')),
  on(ViewSupplierApplicationActions.request, (state) => handleRequest(state, 'viewApplication')),
  on(ViewSupplierApplicationActions.success, (state, { response }) =>
    handleSuccess(state, 'viewApplication', response),
  ),
  on(ViewSupplierApplicationActions.failure, (state, { error }) =>
    handleFailure(state, 'viewApplication', error),
  ),
  on(ViewSupplierApplicationActions.clearState, (state) => handleClear(state, 'viewApplication')),
  on(RevokeSupplierPrequalificationActions.request, (state) => handleRequest(state, 'revokeSupplierPrequalification')),
  on(RevokeSupplierPrequalificationActions.success, (state, { response }) =>
    handleSuccess(state, 'revokeSupplierPrequalification', response),
  ),
  on(RevokeSupplierPrequalificationActions.failure, (state, { error }) =>
    handleFailure(state, 'revokeSupplierPrequalification', error),
  ),
  on(RevokeSupplierPrequalificationActions.clearState, (state) => handleClear(state, 'revokeSupplierPrequalification')),
);
